import { render, staticRenderFns } from "./add.vue?vue&type=template&id=1fcf09d9&scoped=true&"
import script from "./add.js?vue&type=script&lang=js&"
export * from "./add.js?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&lang=css&"
import style1 from "./add.vue?vue&type=style&index=1&id=1fcf09d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcf09d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fcf09d9')) {
      api.createRecord('1fcf09d9', component.options)
    } else {
      api.reload('1fcf09d9', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=1fcf09d9&scoped=true&", function () {
      api.rerender('1fcf09d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/comment/add/add.vue"
export default component.exports